module.exports = ArgonautGlobalStore;